import { render, staticRenderFns } from "./AccountReportClassTable.vue?vue&type=template&id=e96c09bc&scoped=true&"
import script from "./AccountReportClassTable.vue?vue&type=script&lang=js&"
export * from "./AccountReportClassTable.vue?vue&type=script&lang=js&"
import style0 from "./AccountReportClassTable.vue?vue&type=style&index=0&id=e96c09bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96c09bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
